/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileAttachmentDto } from './FileAttachmentDto';
import {
    FileAttachmentDtoFromJSON,
    FileAttachmentDtoFromJSONTyped,
    FileAttachmentDtoToJSON,
    FileAttachmentDtoToJSONTyped,
} from './FileAttachmentDto';

/**
 * 
 * @export
 * @interface ChatRequestDto
 */
export interface ChatRequestDto {
    /**
     * The message to send to the AI chatbot
     * @type {string}
     * @memberof ChatRequestDto
     */
    message?: string;
    /**
     * Optional conversation ID to maintain context
     * @type {string}
     * @memberof ChatRequestDto
     */
    conversationId?: string;
    /**
     * Array of Firebase Storage files to analyze (supports images, documents, audio, video)
     * @type {Array<FileAttachmentDto>}
     * @memberof ChatRequestDto
     */
    attachments?: Array<FileAttachmentDto>;
    /**
     * Treatment plan ID
     * @type {string}
     * @memberof ChatRequestDto
     */
    treatmentPlanId?: string;
    /**
     * Patient ID for doctor to query about specific patient
     * @type {string}
     * @memberof ChatRequestDto
     */
    patientId?: string;
    /**
     * Start date for wearable data range (ISO 8601 format). If both start and end dates are omitted, defaults to 7 days ago.
     * @type {string}
     * @memberof ChatRequestDto
     */
    wearableStartDate?: string;
    /**
     * End date for wearable data range (ISO 8601 format). If both start and end dates are omitted, defaults to current date.
     * @type {string}
     * @memberof ChatRequestDto
     */
    wearableEndDate?: string;
    /**
     * List of diagnostic/genetics report IDs to include in context. Empty or omitted = none.
     * @type {Array<string>}
     * @memberof ChatRequestDto
     */
    diagnosticFileIds?: Array<string>;
    /**
     * List of treatment plan IDs to attach. For each plan, PDF is preferred; TXT is used as fallback.
     * @type {Array<string>}
     * @memberof ChatRequestDto
     */
    treatmentPlanIds?: Array<string>;
    /**
     * List of instruction IDs to attach. For each instruction, PDF is preferred; TXT is used as fallback.
     * @type {Array<string>}
     * @memberof ChatRequestDto
     */
    instructionIds?: Array<string>;
    /**
     * List of procedure IDs to attach. For each procedure, PDF is preferred; TXT is used as fallback.
     * @type {Array<string>}
     * @memberof ChatRequestDto
     */
    procedureIds?: Array<string>;
}

/**
 * Check if a given object implements the ChatRequestDto interface.
 */
export function instanceOfChatRequestDto(value: object): value is ChatRequestDto {
    return true;
}

export function ChatRequestDtoFromJSON(json: any): ChatRequestDto {
    return ChatRequestDtoFromJSONTyped(json, false);
}

export function ChatRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileAttachmentDtoFromJSON)),
        'treatmentPlanId': json['treatmentPlanId'] == null ? undefined : json['treatmentPlanId'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'wearableStartDate': json['wearableStartDate'] == null ? undefined : json['wearableStartDate'],
        'wearableEndDate': json['wearableEndDate'] == null ? undefined : json['wearableEndDate'],
        'diagnosticFileIds': json['diagnosticFileIds'] == null ? undefined : json['diagnosticFileIds'],
        'treatmentPlanIds': json['treatmentPlanIds'] == null ? undefined : json['treatmentPlanIds'],
        'instructionIds': json['instructionIds'] == null ? undefined : json['instructionIds'],
        'procedureIds': json['procedureIds'] == null ? undefined : json['procedureIds'],
    };
}

export function ChatRequestDtoToJSON(json: any): ChatRequestDto {
    return ChatRequestDtoToJSONTyped(json, false);
}

export function ChatRequestDtoToJSONTyped(value?: ChatRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'conversationId': value['conversationId'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileAttachmentDtoToJSON)),
        'treatmentPlanId': value['treatmentPlanId'],
        'patientId': value['patientId'],
        'wearableStartDate': value['wearableStartDate'],
        'wearableEndDate': value['wearableEndDate'],
        'diagnosticFileIds': value['diagnosticFileIds'],
        'treatmentPlanIds': value['treatmentPlanIds'],
        'instructionIds': value['instructionIds'],
        'procedureIds': value['procedureIds'],
    };
}

